enum ConditionSignalType {
  NA = 0, // To be used for objects
  Image = 10,
  ImageList = 15,
  Video = 17,
  Text = 20,
  TextList = 25,
  Number = 30,
  Boolean = 40,
  Color = 50,
  Page = 60,
  Date = 70,
  DateList = 75,
  Font = 85,
  Subtitles = 90,
}

// the ConditionSignalTypeName enum correlates to the ConditionSignalType enum
enum ConditionSignalTypeName {
  NA = 'N/A', // To be used for objects
  Image = 'Image',
  ImageList = 'Image List',
  Video = 'Video',
  Text = 'Text',
  TextList = 'Text List',
  Number = 'Number',
  Boolean = 'Boolean',
  Color = 'Color',
  Page = 'Page (URL)',
  Date = 'Date',
  DateList = 'Date List',
  Font = 'Font',
  Subtitles = 'Subtitles',
}

enum RelatedCardType {
  Condition = 'Condition',
  Schedule = 'Schedule',
  Creative = 'Creative',
  Weighted = 'Weighted',
}

export {ConditionSignalType, ConditionSignalTypeName, RelatedCardType};
